import React, { useState, useEffect } from 'react';
import '../assets/ManageCompany.css';

import SkipEmiModal from '../modals/SkipEmiModal';
// import WebsiteServicesModal from '../modals/WebsiteServicesModal';
import AddTeamsModal from '../modals/AddTeamsModal';
import AddLegalDocsModal from '../modals/AddLegalDocsModal';
import CompanyDocumentModal from '../modals/CompanyDocumentModal';

const ManageCompanyDetails = () => {
  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [companyId, setCompanyId] = useState(null); // store company ID for update
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    cin: '',
    whatsapp: '',
    copyright: '',
    address: '',
    registeredAddress: '', // new field added
    domain: '',
    subdomain: '',
    superAdminId,
  });

  const [logoFile, setLogoFile] = useState(null);
  const [faviconFile, setFaviconFile] = useState(null);
  const [qrFile, setQrFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [faviconPreview, setFaviconPreview] = useState('');
  const [qrPreview, setQrPreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [fetchError, setFetchError] = useState('');

  // Fetch company details by superAdminId
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          setCompanyId(data.id); // save company ID for update
          setFormData({
            name: data.name || '',
            email: data.email || '',
            contact: data.contact || '',
            cin: data.cin || '',
            whatsapp: data.whatsapp || '',
            copyright: data.copyright || '',
            address: data.address || '',
            registeredAddress: data.address || '', // uses same address field from API
            domain: data.domain || '',
            subdomain: data.subdomain || '',
            superAdminId,
          });

          if (data.logo)
            setLogoPreview(`https://payyug.in/${data.logo.replace(/^images\//, '')}`);
          if (data.favicon)
            setFaviconPreview(`https://payyug.in/${data.favicon.replace(/^images\//, '')}`);
          if (data.qrCodeImage)
            setQrPreview(`https://payyug.in/${data.qrCodeImage.replace(/^images\//, '')}`);
        } else {
          setFetchError('');
        }
      } catch (err) {
        setFetchError('Error fetching company: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleImagePreview = (e, setPreview, setFile) => {
    const file = e.target.files?.[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setFile(null);
      setPreview('');
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const superAdminId=localStorage.getItem("adminuserId");
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if(companyId){
          if(key!=='domain' && key!=='subdomain'){
            data.append(key, value)
          }
        }else{
          data.append(key,value)
        }
      });
      if (logoFile) data.append('logo', logoFile);
      if (faviconFile) data.append('favicon', faviconFile);
      if (qrFile) data.append('qrcode', qrFile);
     

      let url = 'https://payyug.in/api/create-company';
      let method = 'POST';

      if (companyId) {
        url = `https://payyug.in/api/update-company/${companyId}`;
        method = 'PUT';
      }

      const response = await fetch(url, { method, body: data });
      const result = await response.json();

      if (response.ok) {
        alert('Company details saved successfully!');
      } else {
        alert('Submission failed: ' + (result.message || JSON.stringify(result)));
      }
    } catch (err) {
      alert('Server error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { id: 'name', label: 'Company Name', type: 'text', placeholder: 'Enter Company Name' },
    { id: 'email', label: 'Company Email', type: 'email', placeholder: 'Enter Company Email' },
    { id: 'contact', label: 'Company Contact', type: 'text', placeholder: 'Enter Company Contact Number' },
    { id: 'cin', label: 'Company CIN', type: 'text', placeholder: 'Enter Company CIN' },
    { id: 'whatsapp', label: 'Company Whatsapp No', type: 'text', placeholder: 'Enter Company Whatsapp Number' },
    { id: 'copyright', label: 'Copyright Name', type: 'text', placeholder: 'Enter Copyright Name' },
    { id: 'address', label: 'Company Address', type: 'text', placeholder: 'Enter Company Address' },
    { id: 'registeredAddress', label: 'Registered Address', type: 'text', placeholder: 'Enter Registered Address' }, // added new field
    { id: 'domain', label: 'Company Domain', type: 'text', placeholder: 'Enter Company Domain' },
    { id: 'subdomain', label: 'Company SubDomain', type: 'text', placeholder: 'Enter SubDomain Domain' },
  ];

  return (
    <div className="ManageCompanyWrapper">
      <div className="ManageCompanyContainer">
        <h2>Manage Company Details</h2>
        <p className="ManageCompanySubtitle">Edit and update company details.</p>
        {loading && <p>Loading...</p>}
        {fetchError && <p style={{ color: 'red' }}>{fetchError}</p>}

        <div className="ManageCompanyActions">
          <button className="ManageCompanyActionBtn" onClick={() => setOpenModal('emi')}>Skip EMI On</button>
          {/* <button className="ManageCompanyActionBtn" onClick={() => setOpenModal('website')}>Manage Website Services</button> */}
          <button className="ManageCompanyActionBtn" onClick={() => setOpenModal('teams')}>Add Teams</button>
          <button className="ManageCompanyActionBtn" onClick={() => setOpenModal('legal')}>Add Legal Doc</button>
          <button className="ManageCompanyActionBtn" onClick={() => setOpenModal('companyDoc')}>Upload Stamp & Signature</button>
        </div>

        <form className="ManageCompanyForm" onSubmit={handleSubmit}>
          {fields.map(({ id, label, type, placeholder }) => (
            <div key={id} className="ManageCompanyField">
              <label htmlFor={id} className="ManageCompanyLabel">{label}</label>
              <input
                id={id}
                type={type}
                value={formData[id]}
                placeholder={placeholder}
                onChange={handleChange}
                className="ManageCompanyInput"
                readOnly={(id==='domain'||id==='subdomain')&& Boolean(companyId)}
                style={
                  (id==='domain'||id==='subdomain') && companyId?{
                    backgroundColor:"#f5f5f5",cursor:'not-allowed'
                  }:{}
                }
                required
              />
            </div>
          ))}

          {[{ label: 'Company Logo', preview: logoPreview, setPreview: setLogoPreview, setFile: setLogoFile },
            { label: 'Favicon', preview: faviconPreview, setPreview: setFaviconPreview, setFile: setFaviconFile },
            { label: 'Company QR Code', preview: qrPreview, setPreview: setQrPreview, setFile: setQrFile }].map(({ label, preview, setPreview, setFile }) => (
              <div key={label} className="ManageCompanyField">
                <label className="ManageCompanyLabel">{label}</label>
                <input type="file" accept="image/*" className="ManageCompanyFileInput"
                  onChange={(e) => handleImagePreview(e, setPreview, setFile)} />
                {preview && <img src={preview} alt={`${label} Preview`} className="ManageCompanyImageSquare" />}
              </div>
            ))}

          <div className="ManageCompanySubmitRow">
            <button type="submit" className="ManageCompanySubmitBtn" disabled={loading}>
              {loading ? 'Submitting...' : companyId ? 'Update Company' : 'Create Company'}
            </button>
          </div>
        </form>
      </div>

      {openModal === 'emi' && <SkipEmiModal onClose={() => setOpenModal(null)} />}
      {/* {openModal === 'website' && <WebsiteServicesModal onClose={() => setOpenModal(null)} />} */}
      {openModal === 'teams' && <AddTeamsModal onClose={() => setOpenModal(null)} />}
      {openModal === 'legal' && <AddLegalDocsModal onClose={() => setOpenModal(null)} />}
      {openModal === 'companyDoc' && <CompanyDocumentModal onClose={() => setOpenModal(null)} />}
    </div>
  );
};

export default ManageCompanyDetails;

